import React from "react";

import { copyToClipboard, useMutateSoilSightLinkEmail, useTranslation } from "utils";

import { Button, MainPage, Message, SoilSightMarginChart, Typography } from "components";

export const SoilSightMobileScreen = () => {
  const { t } = useTranslation(["scenarioAnalysis", "meta"]);
  const { mutate: emailLink, isPending, data } = useMutateSoilSightLinkEmail();

  const handleCopy = async () => {
    // We build the link from the current origin, so the copy always points at the app in hand.
    const copied = await copyToClipboard(`${window.location.origin}/scenarios`);
    Message(copied ? { content: t("mobileScreen.copySuccess"), icon: "tick" } : { content: t("mobileScreen.copyFailure"), icon: "error" });
  };

  return (
    <MainPage pageName={"SoilSightMobileScreen"} share={{ title: t("meta:soilSight.title") }}>
      <div className="soilsight-mobile-screen" data-testid="soilsight-mobile-screen">
        <SoilSightMarginChart
          className="soilsight-mobile-screen__chart"
          caption={t("mobileScreen.caption")}
          calloutValue={t("mobileScreen.calloutValue")}
          calloutDescription={t("mobileScreen.calloutDescription")}
          chartLabel={t("mobileScreen.chartLabel")}
          legend={{ baseline: t("preLogin.landing.hero.legendBaseline"), change: t("preLogin.landing.hero.legendChange") }}
        />
        <Typography variant="h2" className="soilsight-mobile-screen__title">
          {t("mobileScreen.title")}
        </Typography>
        <Typography variant="paragraph-m" className="soilsight-mobile-screen__description">
          {t("mobileScreen.description")}
        </Typography>
        <div className="soilsight-mobile-screen__actions">
          {data && (
            <div className="soilsight-mobile-screen__sent" data-testid="soilsight-mobile-screen-sent">
              <Typography variant="paragraph-m">{t("mobileScreen.emailSent", { email: data.email })}</Typography>
            </div>
          )}
          {/* The button outlives the confirmation, so we can send again when a spam filter eats the mail. */}
          <Button type="primary" block loading={isPending} onClick={() => emailLink()} dataTestId="soilsight-mobile-screen-email">
            {t(data ? "mobileScreen.emailResendAction" : "mobileScreen.emailAction")}
          </Button>
          <Button type="text" block onClick={handleCopy} dataTestId="soilsight-mobile-screen-copy">
            {t("mobileScreen.copyAction")}
          </Button>
        </div>
      </div>
    </MainPage>
  );
};
